<div>
	<bb-page-header [icon]="'chart-line-up'" [title]="'DASHBOARD' | translate">
		<ul class="tabs">
			<li>
				<a [routerLink]="['/adservices/dashboard/outstream']" routerLinkActive=""
					[class.active]="activeTab === 'outstream'">
					<i class="fa fa-tags"></i> {{ 'OUTSTREAM' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/adservices/dashboard/instream']" routerLinkActive=""
					[class.active]="activeTab === 'instream'">
					<i class="fa fa-tags"></i> {{ 'INSTREAM' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/adservices/dashboard/adschedules']" routerLinkActive=""
					[class.active]="activeTab === 'adschedules'">
					<i class="fa fa-tags"></i> {{ 'AD_SCHEDULES' | translate }}
				</a>
			</li>
		</ul>
	</bb-page-header>

	<div class="body-column tab-container">
		<ad-dashboard-outstream [hidden]="activeTab !== 'outstream'"></ad-dashboard-outstream>
		<ad-dashboard-instream [hidden]="activeTab !== 'instream'"></ad-dashboard-instream>
		<ad-dashboard-adschedules [hidden]="activeTab !== 'adschedules'"></ad-dashboard-adschedules>
	</div>
</div>
